module.exports = __webpack_public_path__ + "static/media/qris-scan.c14a3051.jpeg";